import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const useDateFilter = (data, dataSeter, placeHolder) => {
  const handleDateChange = (selectedDate) => {
    console.log("data", data);
    const filteredData = data.filter((ele) => {
      return (
        selectedDate.$d >= new Date(ele.startDate.$date) &&
        selectedDate.$d <= new Date(ele.endDate.$date)
      );
    });
    dataSeter(filteredData);
  };
  const DateFilter = () => {
    return (
      <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker label={placeHolder} onChange={handleDateChange} />
          </DemoContainer>
        </LocalizationProvider>
      </>
    );
  };
  return { DateFilter };
};

export default useDateFilter;
